module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Angi Morgan\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('Br', [_c('Br', [_vm._v("Using actual Texas settings and realistic characters, this "), _c('I', [_vm._v("USA Today")]), _vm._v(" and "), _c('I', [_vm._v("Publisher's Weekly")]), _vm._v(" bestseller, creates stories with characters who put everything on the line. Angi is an 11th generation Texan who lives there with her husband and 'four-legged' kids. Find her at AngiMorganAuthor.com")], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/a9PdBg/tc-custom/9781488033100.jpg?1705950839795",
      "alt": "This image is the cover for the book Ranger Defender, Texas Brothers of Company B"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ranger Defender, Texas Brothers of Company B\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Angi Morgan proves that she is one of the giants of romantic suspense . . . The villain is as masterful a creation as they come . . . fantastic.” —"), _c('i', [_vm._v("Fresh Fiction")])]), _c('br'), _c('br'), _vm._v("She needed a miracle."), _c('br'), _c('br'), _vm._v("She got a Texas Ranger."), _c('br'), _c('br'), _vm._v("Vivian Watts’s mission to prove her brother’s innocence has left her destitute and desperate. So when Texas Ranger Slate Thompson arrives with his knock-me-out blue eyes and belief in her case, she dares to hope again . . . until her apartment is burned to the ground. Slate offers refuge at his ranch, but when evidence suggests Vivian is being hunted . . . can he face down the real killer to protect her?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0